/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Status_SuspendedInputs */



/**
* | output |
* | --- |
* | "Suspended" |
*
* @param {Dashboard_Status_SuspendedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const dashboard_status_suspended = /** @type {((inputs?: Dashboard_Status_SuspendedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Status_SuspendedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приостановлен")
	return /** @type {LocalizedString} */ ("Suspended")
});